import React, { useContext, useState } from "react";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Grid, Container } from '@material-ui/core';
import TextfieldEnLetters from '../../FormsUI/TextfieldEnLetters';
import TextfieldEnEmail from '../../FormsUI/TextfieldEnEmail';
import TextfieldPhone from '../../FormsUI/TextfieldPhone';
import UsersService from '../../../services/users.service';
import AppButton from 'components/FormsUI/AppButton/appButton';
import ToastContext from "store/ToastContext";

const AddEditUser=(props)=> {
    const { openToast } = useContext(ToastContext);
    const [isLoading, setIsLoading] = useState(false);
    var airlineCode = props.airlineCode;
    var action = props.action;

    const handleSubmit = async (values) => {
        setIsLoading(true);
        values.AirlineCode = airlineCode;
        values.Role = "user";
        if (props.action === "Update") {
            var updateUser = await UsersService.updateUser(values);
            if (updateUser.code === 0) {
                openToast("User updated", "success");
                props.onSubmitted(values, "update");
            }
            else {
                openToast("Error occured in updating user", "error");
                setIsLoading(false);
            }
        } else {

            var insertUser = await UsersService.addUser(values);
            if (insertUser.code === 0) {
                openToast("User added", "success");
                props.onSubmitted(insertUser, "insert");
            }
            else if (insertUser.code === 1 || insertUser.code === 2) {
                openToast(insertUser.description, "error", {duration:6000});
                setIsLoading(false);
            }
            else {
                openToast("Error occured in inserting user", "error");
                setIsLoading(false);
            }
        }
    }

    return (
        <Grid container>
            <Grid item xs={12}>
                <Container maxWidth="md">
                    <div>
                        <Formik
                            initialValues={{
                                LastName: props.user?.lastName ? props.user?.lastName : '',
                                FirstName: props.user?.firstName ? props.user?.firstName : '',
                                UserName: props.user?.userName ? props.user?.userName : '',
                                PhoneNumber: props.user?.phoneNumber ? props.user?.phoneNumber : '',
                                FaxNumber: props.user?.faxNumber ? props.user?.faxNumber : '',
                                Role: props.user?.role ? props.user?.role : '',
                            }}
                            onSubmit={(values, { setSubmitting }) => {
                                setSubmitting(true);
                                handleSubmit(values);
                            }}
                            validationSchema={Yup.object().shape({
                                LastName: Yup.string().required('Last Name is required').
                                    matches(/^[a-zA-Z- ]+$/, "Invalid input format"),
                                FirstName: Yup.string().required('First Name is required').
                                    matches(/^[a-zA-Z- ]+$/, "Invalid input format"),
                                UserName: Yup.string().required('User Name is required').email('Please enter valid email address'),
                                PhoneNumber: Yup.string().required('Phone Number is required').
                                    matches(/^\+(?:[0-9]?){6,14}[0-9]$/, 'Invalid input format'),
                                FaxNumber: Yup.string().
                                    matches(/^\+(?:[0-9]?){6,14}[0-9]$/, 'Invalid input format'),
                            })}
                        >
                            {(props) => {
                                const {
                                    values,
                                    handleSubmit,
                                } = props;
                                return (
                                    <Form onSubmit={handleSubmit} noValidate>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextfieldEnLetters name="LastName" label="Last Name"></TextfieldEnLetters>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextfieldEnLetters name="FirstName" label="First Name"></TextfieldEnLetters>
                                            </Grid>
                                            <Grid item xs={12}>
                                                {action !== "Add" ?
                                                    <label>User name: {values.UserName}</label> :
                                                    <TextfieldEnEmail name="UserName" label="User Name"></TextfieldEnEmail>}
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextfieldPhone name="PhoneNumber" label="Phone Number"></TextfieldPhone>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextfieldPhone name="FaxNumber" label="Fax Number"></TextfieldPhone>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <div style={{ paddingBottom: "36px" }}>
                                                </div>
                                            </Grid>
                                            <Grid container className="mb-2 px-2">
                                                <Grid item xs></Grid>
                                                <Grid item xs={2}>
                                                    <AppButton type="submit" classes="rightBtn" label="SUBMIT" isLoading={isLoading} isBlock={true}></AppButton>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Form>
                                )
                            }}
                        </Formik>
                    </div>
                </Container>
            </Grid>
        </Grid>
    )
}

export default AddEditUser;